import { DEFAULT_BORDER } from "../const/excel.const";
/**
 * @description 주어진 행의 각 셀에 얇은 테두리를 적용합니다.
 *
 * @param row ExcelJS.Row 객체로, 테두리를 적용할 행을 나타냅니다.
 */
export function applyBorderEachCell(row) {
    row.eachCell((cell) => {
        cell.border = DEFAULT_BORDER;
    });
}
